import { render, staticRenderFns } from "./inputGroup.vue?vue&type=template&id=a1fcbb52&"
import script from "./inputGroup.vue?vue&type=script&lang=js&"
export * from "./inputGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports